import { themedUseStyletron } from '../../../theme/customTheme'
import { ILight, schema } from './types'
import { OverviewPanelWrapper } from '../../components/OverviewPanelWrapper'
import { FaRegLightbulb } from 'react-icons/fa'
import { ButtonPanel } from './ButtonPanel';

export function OverviewPanel(props: ILight) {
    const [, theme] = themedUseStyletron();


    const onColor = theme.colors.warning;

    return (
        <OverviewPanelWrapper height={theme.appSizes.xSmallAppHeight} {...props} icon={<FaRegLightbulb color={theme.colors.backgroundPrimary} size='100%' />} onColorOverride={onColor}>
            <ButtonPanel {...props}></ButtonPanel>

        </OverviewPanelWrapper >
    );
}

